module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "el-form",
    class: [
      _vm.labelPosition ? 'el-form--label-' + _vm.labelPosition : '',
      {
        'el-form--inline': _vm.inline
      }
    ]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33a346de!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/form/src/form.vue
// module id = 1048
// module chunks = 2